var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglebadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "41px",
    viewBox: "0 0 129 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "googlebadge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "32.0715648%",
    y1: "-6.0957265%",
    x2: "54.461911%",
    y2: "92.1559829%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006884",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AD1D0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-7.52792208%",
    y1: "30.2358998%",
    x2: "91.537013%",
    y2: "70.9239374%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24BBB6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE692",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9404255%",
    y1: "105.754795%",
    x2: "49.9404255%",
    y2: "-3.12739726%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC072",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A5B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.1493421%",
    y1: "89.5089855%",
    x2: "90.4368421%",
    y2: "27.9281683%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#712B8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1D27",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "googlebadge",
    transform: "translate(0.500000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124,40 L4,40 C1.8,40 0,38.2 0,36 L0,4 C0,1.8 1.8,0 4,0 L124,0 C126.2,0 128,1.8 128,4 L128,36 C128,38.2 126.2,40 124,40 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,19.6 L9.8,9.1 C9.8,8.5 10.3,8 10.8,8 C11.3,8 11.5,8.1 11.8,8.3 L31.1,18.9 C31.5,19.1 31.7,19.4 31.7,19.7 C31.7,20 31.5,20.3 31.1,20.5 L11.8,31.1 C11.6,31.2 11.3,31.4 10.8,31.4 C10.3,31.4 9.8,30.9 9.8,30.3 L9.8,19.6 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,19.7 L10.6,8 C10.7,8 10.7,8 10.8,8 C11.3,8 11.5,8.1 11.8,8.3 L26,16.1 L22.3,19.7 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9,23.2 L22.3,19.6 L26,15.9 L31.1,18.7 C31.5,18.9 31.7,19.2 31.7,19.5 C31.7,19.8 31.5,20.1 31.1,20.3 L25.9,23.2 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,31.2 L10.7,31.2 L22.3,19.6 L25.9,23.2 L11.8,30.9 C11.5,31.1 11.3,31.2 10.7,31.2 C10.8,31.2 10.8,31.2 10.7,31.2 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,33.9 C70.6,33.5 70.2,32.8 70,32.4 L71.6,31.7 C71.7,31.9 71.9,32.2 72.1,32.5 C72.5,32.9 73.1,33.3 73.7,33.3 C74.3,33.3 75,33 75.4,32.5 C75.7,32 75.9,31.5 75.9,30.8 L75.9,30.2 C74.7,31.7 72.2,31.5 70.8,29.9 C69.3,28.3 69.3,25.6 70.8,24 C72.3,22.5 74.5,22.3 75.8,23.7 C75.8,23.7 75.8,23.7 75.8,23.7 L75.8,23 L77.5,23 L77.5,30.5 C77.5,32.4 76.8,33.5 75.9,34.2 C75.3,34.7 74.4,34.9 73.6,34.9 C72.7,34.8 71.8,34.5 71.1,33.9 L71.1,33.9 Z M113,34.3 L113,34.3 L114.7,30.3 L111.7,23.4 L113.4,23.4 L115.5,28.3 L117.6,23.4 L119.3,23.4 L114.7,34.3 L113,34.3 L113,34.3 Z M104.9,30.5 L104.9,30.5 C104.4,30 104.2,29.3 104.2,28.6 C104.2,28 104.4,27.4 104.8,27 C105.5,26.3 106.5,26 107.6,26 C108.3,26 108.9,26.1 109.4,26.4 C109.4,25.2 108.4,24.7 107.6,24.7 C106.9,24.7 106.2,25.1 105.9,25.8 L104.4,25.2 C104.7,24.5 105.5,23.2 107.5,23.2 C108.5,23.2 109.5,23.5 110.1,24.2 C110.7,24.9 110.9,25.7 110.9,26.8 L110.9,31 L109.2,31 L109.2,30.3 C109,30.6 108.6,30.8 108.3,31 C107.9,31.2 107.4,31.3 106.9,31.3 C106.3,31.2 105.4,31 104.9,30.5 L104.9,30.5 Z M51.6,26.9 L51.6,26.9 C51.6,24.9 53.1,22.7 55.8,22.7 C58.4,22.7 60,24.9 60,26.9 C60,28.9 58.5,31.1 55.8,31.1 C53.1,31.1 51.6,28.9 51.6,26.9 L51.6,26.9 Z M60.6,26.9 L60.6,26.9 C60.6,24.9 62.1,22.7 64.8,22.7 C67.4,22.7 69,24.9 69,26.9 C69,28.9 67.5,31.1 64.8,31.1 C62.2,31.1 60.6,28.9 60.6,26.9 L60.6,26.9 Z M40.3,29.1 L40.3,29.1 C37.8,26.6 37.9,22.5 40.4,19.9 C41.7,18.6 43.3,18 45,18 C46.6,18 48.2,18.6 49.4,19.8 L48.2,21.1 C46.4,19.3 43.5,19.4 41.8,21.2 C40,23.1 40,26 41.8,27.9 C43.6,29.8 46.6,29.9 48.4,28 C49,27.4 49.2,26.6 49.3,25.8 L45.1,25.8 L45.1,24 L51,24 C51.1,24.4 51.1,24.9 51.1,25.4 C51.1,26.9 50.5,28.4 49.5,29.4 C48.4,30.5 46.8,31.1 45.2,31.1 C43.4,31 41.6,30.4 40.3,29.1 L40.3,29.1 Z M82.6,29.8 L82.6,29.8 C81.1,28.2 81.1,25.5 82.6,23.8 C84.1,22.2 86.6,22.2 88,23.8 C88.5,24.3 88.8,25 89.1,25.7 L83.6,28 C83.9,28.7 84.6,29.3 85.6,29.3 C86.5,29.3 87.1,29 87.7,28.1 L89.2,29.1 L89.2,29.1 C89,29.3 88.8,29.5 88.7,29.7 C87,31.4 84.1,31.4 82.6,29.8 L82.6,29.8 Z M93,31 L93,31 L93,19.9 L96.6,19.9 C98.7,19.9 100.4,21.4 100.4,23.2 C100.4,25 98.9,26.5 97,26.5 L94.8,26.5 L94.8,30.9 L93,30.9 L93,31 Z M101.4,31 L101.4,31 L101.4,19.9 L103.1,19.9 L103.1,31 L101.4,31 L101.4,31 Z M78.8,30.8 L78.8,30.8 L78.8,18.4 L80.6,18.4 L80.6,30.8 L78.8,30.8 L78.8,30.8 Z M109.3,27.7 L109.3,27.7 C108.9,27.4 108.3,27.3 107.7,27.3 C106.5,27.3 105.8,27.9 105.8,28.6 C105.8,29.3 106.5,29.7 107.2,29.7 C108.2,29.7 109.3,28.9 109.3,27.7 L109.3,27.7 Z M58.1,26.9 L58.1,26.9 C58.1,25.7 57.3,24.4 55.8,24.4 C54.3,24.4 53.5,25.7 53.5,26.9 C53.5,28.1 54.3,29.4 55.8,29.4 C57.2,29.4 58.1,28.1 58.1,26.9 L58.1,26.9 Z M67.1,26.9 L67.1,26.9 C67.1,25.7 66.3,24.4 64.8,24.4 C63.3,24.4 62.5,25.7 62.5,26.9 C62.5,28.1 63.3,29.4 64.8,29.4 C66.3,29.4 67.1,28.1 67.1,26.9 L67.1,26.9 Z M76,27.6 L76,27.6 C76,27.5 76,27.4 76.1,27.3 C76.1,27.3 76.1,27.3 76.1,27.3 C76.1,27.2 76.1,27 76.1,26.9 C76.1,26.8 76.1,26.6 76.1,26.5 C76.1,26.5 76.1,26.4 76.1,26.4 C76.1,26.3 76,26.1 76,26 C75.7,25 74.8,24.3 73.9,24.3 C72.7,24.3 71.7,25.5 71.7,26.8 C71.7,28.2 72.7,29.3 74,29.3 C74.8,29.4 75.6,28.7 76,27.6 L76,27.6 Z M83.3,26.7 L83.3,26.7 L87,25.1 C86.6,24.4 86,24.2 85.5,24.2 C84,24.3 83.1,25.9 83.3,26.7 L83.3,26.7 Z M98.6,23.3 L98.6,23.3 C98.6,22.3 97.8,21.6 96.7,21.6 L94.7,21.6 L94.7,25.1 L96.8,25.1 C97.8,25.1 98.6,24.3 98.6,23.3 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.3 32.3 114.3 32.3 114.2 32.3 114.2 32.3 114.2 32.2 114.2 32.2 114.3 32.2 114.3 32.2 114.2 32.2 114.2 32.2 114.2 32.3 114.2 32.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.3 32.3 114.3 32.3 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.3 114.3 32.3 114.3 32.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.3 32.3 114.3 32.3 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.2 114.3 32.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.2 114.4 32.3 114.4 32.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.4 32.3 114.4 32.3 114.4 32.2 114.4 32.2 114.4 32.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.4,32.3 L114.4,32.3 L114.4,32.3 L114.4,32.3 L114.4,32.3 L114.4,32.3 C114.4,32.3 114.4,32.3 114.4,32.3 C114.4,32.3 114.4,32.3 114.4,32.3 L114.4,32.3 C114.4,32.2 114.4,32.2 114.4,32.3 C114.4,32.2 114.4,32.2 114.4,32.3 L114.4,32.3 C114.4,32.2 114.4,32.2 114.4,32.3 C114.4,32.2 114.4,32.2 114.4,32.3 L114.4,32.3 C114.4,32.3 114.4,32.3 114.4,32.3 C114.4,32.3 114.4,32.3 114.4,32.3 L114.4,32.3 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.5 32.3 114.5 32.2 114.5 32.2 114.5 32.2 114.5 32.2 114.5 32.2 114.5 32.3 114.5 32.3 114.5 32.2 114.5 32.2 114.5 32.3 114.5 32.3 114.5 32.2 114.5 32.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 L114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.2 114.5,32.2 114.5,32.3 C114.5,32.3 114.5,32.3 114.5,32.3 C114.5,32.3 114.5,32.3 114.5,32.3 L114.5,32.3 C114.5,32.3 114.5,32.3 114.5,32.3 C114.5,32.3 114.5,32.3 114.5,32.3 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.6 32.2 114.5 32.2 114.5 32.2 114.6 32.2 114.6 32.3 114.6 32.3 114.6 32.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "114.6 32.3 114.6 32.3 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.2 114.6 32.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,10.1 C38.9,8.3 40.2,7.2 41.8,7.2 C42.9,7.2 43.6,7.7 44.1,8.4 L43.3,8.9 C43,8.5 42.5,8.2 41.8,8.2 C40.7,8.2 39.9,9 39.9,10.2 C39.9,11.4 40.7,12.2 41.8,12.2 C42.4,12.2 42.9,11.9 43.1,11.7 L43.1,10.8 L41.5,10.8 L41.5,9.9 L44.2,9.9 L44.2,12 C43.7,12.6 42.9,13 41.9,13 C40.2,13 38.9,11.8 38.9,10.1 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "45.4 12.9 45.4 7.3 49.2 7.3 49.2 8.2 46.3 8.2 46.3 9.6 49.1 9.6 49.1 10.5 46.3 10.5 46.3 12.1 49.2 12.1 49.2 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "52 12.9 52 8.2 50.3 8.2 50.3 7.3 54.7 7.3 54.7 8.2 53 8.2 53 12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,12.9 L58.1,7.3 L59.1,7.3 L59.1,12.9 C59.1,12.9 58.1,12.9 58.1,12.9 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "61.8 12.9 61.8 8.2 60.1 8.2 60.1 7.3 64.5 7.3 64.5 8.2 62.8 8.2 62.8 12.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,10.1 C67.7,8.4 68.9,7.2 70.6,7.2 C72.3,7.2 73.5,8.4 73.5,10.1 C73.5,11.8 72.3,13 70.6,13 C68.9,13 67.7,11.7 67.7,10.1 Z M72.4,10.1 C72.4,8.9 71.7,8.1 70.5,8.1 C69.4,8.1 68.6,9 68.6,10.1 C68.6,11.3 69.3,12.1 70.5,12.1 C71.7,12.1 72.4,11.2 72.4,10.1 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "78.5 12.9 75.6 8.9 75.6 12.9 74.6 12.9 74.6 7.3 75.6 7.3 78.5 11.2 78.5 7.3 79.5 7.3 79.5 12.9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglebadge);
export default __webpack_public_path__ + "static/media/googlebadge.d796803afa0730732c21ce5626260620.svg";
export { ForwardRef as ReactComponent };